/* import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Dropdown } from "./ui/dropdown/Dropdown";
import { DropdownItem } from "./ui/dropdown/DropdownItem";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function LeadsByProjectTypeChart() {
  const [timeFilter, setTimeFilter] = useState("This Month");
  const [typeFilter, setTypeFilter] = useState("Leads");
  const [timeOpen, setTimeOpen] = useState(false);
  const [typeOpen, setTypeOpen] = useState(false);
  const [leadsData, setLeadsData] = useState([]); 


  // Modal filter for Project Type + Units
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [selectedFilterCategory, setSelectedFilterCategory] = useState("projectType");
  const [filters, setFilters] = useState({ projectType: "All", units: "All" });

  const projectTypes = ["1BHK", "2BHK", "3BHK", "4BHK", "Villa", "Studio", "Commercial"];
  const unitCounts = ["1", "2", "3", "4", "5", "5+", "10", "10+", "15", "15+", "20"];

  useEffect(() => {
    fetchManufacturerLeads();
  }, []);



  // Example dataset (random numbers for demonstration)
  const dataSets = {
    Leads: {
      "1BHK": { "1": 50, "2": 40, "3": 30, "4": 20, "5": 10 },
      "2BHK": { "1": 60, "2": 50, "3": 40, "4": 30, "5": 20 },
      "3BHK": { "1": 70, "2": 60, "3": 50, "4": 40, "5": 30 },
      "4BHK": { "1": 80, "2": 70, "3": 60, "4": 50, "5": 40 },
      Villa: { "1": 90, "2": 80, "3": 70, "4": 60, "5": 50 },
      Studio: { "1": 30, "2": 25, "3": 20, "4": 15, "5": 10 },
      Commercial: { "1": 20, "2": 18, "3": 15, "4": 12, "5": 10 },
    },
    Sales: {
      "1BHK": { "1": 10, "2": 8, "3": 6, "4": 5, "5": 4 },
      "2BHK": { "1": 15, "2": 12, "3": 10, "4": 8, "5": 6 },
      "3BHK": { "1": 20, "2": 18, "3": 15, "4": 12, "5": 10 },
      "4BHK": { "1": 25, "2": 20, "3": 18, "4": 15, "5": 12 },
      Villa: { "1": 30, "2": 28, "3": 25, "4": 22, "5": 20 },
      Studio: { "1": 8, "2": 7, "3": 6, "4": 5, "5": 4 },
      Commercial: { "1": 5, "2": 4, "3": 3, "4": 3, "5": 2 },
    },
    Revenue: {
      "1BHK": { "1": 5000, "2": 4000, "3": 3000, "4": 2000, "5": 1000 },
      "2BHK": { "1": 6000, "2": 5000, "3": 4000, "4": 3000, "5": 2000 },
      "3BHK": { "1": 7000, "2": 6000, "3": 5000, "4": 4000, "5": 3000 },
      "4BHK": { "1": 8000, "2": 7000, "3": 6000, "4": 5000, "5": 4000 },
      Villa: { "1": 9000, "2": 8000, "3": 7000, "4": 6000, "5": 5000 },
      Studio: { "1": 3000, "2": 2500, "3": 2000, "4": 1500, "5": 1000 },
      Commercial: { "1": 2000, "2": 1800, "3": 1500, "4": 1200, "5": 1000 },
    },
  };

  // Prepare chart data based on selected filters
  let filteredCategories = [];
  let filteredData = [];

  if (filters.projectType === "All" && filters.units === "All") {
    filteredCategories = projectTypes;
    filteredData = projectTypes.map(
      (p) => Object.values(dataSets[typeFilter][p]).reduce((a, b) => a + b, 0)
    );
  } else if (filters.projectType === "All") {
    filteredCategories = projectTypes;
    filteredData = projectTypes.map(
      (p) => dataSets[typeFilter][p][filters.units] || 0
    );
  } else if (filters.units === "All") {
    filteredCategories = [filters.projectType];
    filteredData = [
      Object.values(dataSets[typeFilter][filters.projectType]).reduce(
        (a, b) => a + b,
        0
      ),
    ];
  } else {
    filteredCategories = [`${filters.projectType} / ${filters.units}`];
    filteredData = [dataSets[typeFilter][filters.projectType][filters.units] || 0];
  }

  // Distinct colors per data type
  const chartColors = { Leads: "#4CAF50", Sales: "#2196F3", Revenue: "#FF9800" };

  const options = {
    colors: [chartColors[typeFilter]],
    chart: { fontFamily: "Inter, sans-serif", type: "bar", height: 180, toolbar: { show: false } },
    plotOptions: { bar: { horizontal: false, columnWidth: "38%", borderRadius: 6 } },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 3, colors: ["transparent"] },
    grid: { borderColor: "#e5e7eb", strokeDashArray: 4 },
    xaxis: { categories: filteredCategories, labels: { style: { colors: "#6b7280", fontSize: "13px" } } },
    yaxis: {
      labels: {
        style: { colors: "#6b7280", fontSize: "12px" },
        formatter: (val) => (typeFilter === "Revenue" ? `₹${val / 1000}k` : val),
      },
    },
    tooltip: {
      theme: "dark",
      y: { formatter: (val) => (typeFilter === "Revenue" ? `₹${val.toLocaleString()}` : `${val} ${typeFilter}`) },
    },
  };

  const series = [{ name: typeFilter, data: filteredData }];

const FilterButton = ({ label, onClick }) => (
    <button
      onClick={onClick}
      className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-sm rounded-lg shadow-sm transition whitespace-nowrap"
    >
      {label} ▼
    </button>
  );

const fetchManufacturerLeads = async (period = "year") => {
  try {
    //const userData = JSON.parse(sessionStorage.getItem("userData"));
    const manufacturerId = "678e1bdf3ce3c1c267977a1e"userData?._id;   
    //const token = userData?.token;

    if (!manufacturerId || !token) {
      console.error("Manufacturer ID or token not found in session storage");
      return;
    }

    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const apiUrl = `${fetchUrl}manufacturer/get-manufacturer-leads?manufacturerId=${manufacturerId}&period=${period}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
       // "x-token": token, 
      },
    });

    const data = await response.json();
    console.log("Manufacturer Leads Data:", data);

    if (response.ok && data) {
      setLeadsData(data);  
    } else {
      console.error("Failed to fetch leads:", data.message);
    }
  } catch (error) {
    console.error("Error in fetchManufacturerLeads:", error);
  }
};
  
return (
    <div className="rounded-2xl border border-gray-200 bg-white px-4 dark:bg-gray-900 sm:px-5 pt-5 pb-3 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <h3 className="text-base sm:text-lg font-semibold text-gray-800 flex-1 min-w-[200px]">
          {`${typeFilter} from ${filters.projectType} / ${filters.units} — ${timeFilter}`}
        </h3>

        <div className="flex flex-wrap items-center gap-2">
          <div className="relative">
            <FilterButton label={typeFilter} onClick={() => setTypeOpen(!typeOpen)} />
            <Dropdown isOpen={typeOpen} onClose={() => setTypeOpen(false)}>
              {Object.keys(dataSets).map((key) => (
                <DropdownItem
                  key={key}
                  onItemClick={() => {
                    setTypeFilter(key);
                    setTypeOpen(false);
                  }}
                >
                  {key}
                </DropdownItem>
              ))}
            </Dropdown>
          </div>

          <div className="relative">
            <FilterButton label={timeFilter} onClick={() => setTimeOpen(!timeOpen)} />
            <Dropdown isOpen={timeOpen} onClose={() => setTimeOpen(false)}>
              {["This Month", "This Quarter", "This Year"].map((key) => (
                <DropdownItem
                  key={key}
                  onItemClick={() => {
                    setTimeFilter(key);
                    setTimeOpen(false);
                  }}
                >
                  {key}
                </DropdownItem>
              ))}
            </Dropdown>
          </div>

          <div>
            <FilterButton
              label={`${filters.projectType} / ${filters.units}`}
              onClick={() => setShowFilterModal(true)}
            />
          </div>
        </div>
      </div>

      <Chart options={options} series={series} type="bar" height={180} />

      {showFilterModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 p-3">
          <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-2xl w-full max-w-lg border border-gray-200 relative flex flex-col md:flex-row">
            <XMarkIcon
              className="w-6 h-6 absolute top-3 right-3 cursor-pointer text-gray-500 hover:text-gray-700"
              onClick={() => setShowFilterModal(false)}
            />

            <div className="md:w-1/3 border-b md:border-b-0 md:border-r pb-3 md:pb-0 pr-0 md:pr-4 mb-4 md:mb-0">
              <h2 className="text-md font-semibold mb-3">Filter By</h2>
              <ul className="flex md:flex-col gap-2">
                <li
                  className={`cursor-pointer px-3 py-2 rounded-lg transition text-sm sm:text-base ${
                    selectedFilterCategory === "projectType"
                      ? "bg-blue-100 text-blue-700"
                      : "hover:bg-gray-100"
                  }`}
                  onClick={() => setSelectedFilterCategory("projectType")}
                >
                  Project Type
                </li>
                <li
                  className={`cursor-pointer px-3 py-2 rounded-lg transition text-sm sm:text-base ${
                    selectedFilterCategory === "units"
                      ? "bg-blue-100 text-blue-700"
                      : "hover:bg-gray-100"
                  }`}
                  onClick={() => setSelectedFilterCategory("units")}
                >
                  Units
                </li>
              </ul>
            </div>

            <div className="md:w-2/3 md:pl-4 animate-fadeIn">
              <h3 className="text-md font-semibold mb-3">
                {selectedFilterCategory === "projectType" ? "Select Project Type" : "Select Units"}
              </h3>
              <ul className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                <li
                  className={`cursor-pointer px-3 py-2 rounded-lg text-sm sm:text-base ${
                    (selectedFilterCategory === "projectType" && filters.projectType === "All") ||
                    (selectedFilterCategory === "units" && filters.units === "All")
                      ? "bg-blue-500 text-white"
                      : "hover:bg-gray-100"
                  }`}
                  onClick={() => {
                    setFilters((f) => ({ ...f, [selectedFilterCategory]: "All" }));
                    setShowFilterModal(false);
                  }}
                >
                  All
                </li>
                {(selectedFilterCategory === "projectType" ? projectTypes : unitCounts).map((item) => (
                  <li
                    key={item}
                    className={`cursor-pointer px-3 py-2 rounded-lg text-sm sm:text-base ${
                      filters[selectedFilterCategory] === item
                        ? "bg-blue-500 text-white"
                        : "hover:bg-gray-100"
                    }`}
                    onClick={() => {
                      setFilters((f) => ({ ...f, [selectedFilterCategory]: item }));
                      setShowFilterModal(false);
                    }}
                  >
                    {selectedFilterCategory === "units" ? `${item} Units` : item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
 */



import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Dropdown } from "./ui/dropdown/Dropdown";
import { DropdownItem } from "./ui/dropdown/DropdownItem";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function LeadsByProjectTypeChart() {
  const [timeFilter, setTimeFilter] = useState("This Month");
  const [typeFilter, setTypeFilter] = useState("Leads");
  const [timeOpen, setTimeOpen] = useState(false);
  const [typeOpen, setTypeOpen] = useState(false);
  const [leadsData, setLeadsData] = useState({ leadsByType: {} });

  // Modal filter for Project Type + Units
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [selectedFilterCategory, setSelectedFilterCategory] = useState("projectType");
  const [filters, setFilters] = useState({ projectType: "All", units: "All" });

  const projectTypes = ["1BHK", "2BHK", "3BHK", "4BHK", "Villa", "Studio", "Commercial"];
  const unitCounts = ["1", "2", "3", "4", "5", "5+", "10", "10+", "15", "15+", "20"];

  useEffect(() => {
    fetchManufacturerLeads(getPeriodKey(timeFilter));
  }, [timeFilter]);

  const getPeriodKey = (label) => {
    switch (label) {
      case "This Week":
        return "week";
      case "This Month":
        return "month";
      case "This Quarter":
        return "quarter";
      case "This Year":
        return "year";
      default:
        return "year";
    }
  };

  const fetchManufacturerLeads = async (period = "year") => {
    try {
      const manufacturerId = sessionStorage.getItem('userId');
      const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
      const apiUrl = `${fetchUrl}manufacturer/get-manufacturer-leads?manufacturerId=${manufacturerId}&period=${period}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      const data = await response.json();
      console.log("Manufacturer Leads Data:", data);
      if (response.ok && data) {
        setLeadsData(data);
      } else {
        console.error("Failed to fetch leads:", data.message);
      }
    } catch (error) {
      console.error("Error in fetchManufacturerLeads:", error);
    }
  };

  // Map API data (leadsByType) to chart
  const chartCategories = Object.keys(leadsData?.leadsByType || {});
  const chartData = Object.values(leadsData?.leadsByType || {});

  const chartColors = { Leads: "#4CAF50", Sales: "#2196F3", Revenue: "#FF9800" };

  const options = {
    colors: [chartColors[typeFilter]],
    chart: { fontFamily: "Inter, sans-serif", type: "bar", height: 180, toolbar: { show: false } },
    plotOptions: { bar: { horizontal: false, columnWidth: "38%", borderRadius: 6 } },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 3, colors: ["transparent"] },
    grid: { borderColor: "#e5e7eb", strokeDashArray: 4 },
    xaxis: { categories: chartCategories, labels: { style: { colors: "#6b7280", fontSize: "13px" } } },
    yaxis: {
      labels: { style: { colors: "#6b7280", fontSize: "12px" } },
    },
    tooltip: {
      theme: "dark",
      y: { formatter: (val) => `${val} ${typeFilter}` },
    },
  };

  const series = [{ name: typeFilter, data: chartData }];

  const FilterButton = ({ label, onClick }) => (
    <button
      onClick={onClick}
      className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-sm rounded-lg shadow-sm transition whitespace-nowrap"
    >
      {label} ▼
    </button>
  );

return (
  <div className="rounded-2xl border border-gray-200 bg-white px-4 sm:px-5 pt-5 pb-3 shadow-sm">
    {/* Header */}
    <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
      <h3 className="text-base sm:text-lg font-semibold text-gray-800 flex-1 min-w-[200px]">
        {`${typeFilter} — ${timeFilter}`}
      </h3>

      <div className="flex flex-wrap items-center gap-2">
        {/* Time Filter */}
        <div className="relative">
          <FilterButton label={timeFilter} onClick={() => setTimeOpen(!timeOpen)} />
          <Dropdown isOpen={timeOpen} onClose={() => setTimeOpen(false)}>
            {["This Week", "This Month", "This Quarter", "This Year"].map((key) => (
              <DropdownItem
                key={key}
                onItemClick={() => {
                  setTimeFilter(key);
                  setTimeOpen(false);
                }}
              >
                {key}
              </DropdownItem>
            ))}
          </Dropdown>
        </div>
      </div>
    </div>

    <Chart options={options} series={series} type="bar" height={180} />
  </div>
);

}
